/* eslint-disable no-debugger */
import { useEffect } from 'react';

import validate from './MemberCompetitionCategoryValidation';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';

import useBasePersonData from '@usas/ui-web/state/personBase/UseBasePersonData';
import useCompetitionGenderTypeData from '@usas/ui-web/state/competitionGender/UseCompetitionGenderTypeData';
import useOfficialCompetitionCategoryData from '../../../state/member/memberOfficialCompetitionCategory/UseOfficialCompetitionCategoryData';

import useForm from '@usas/ui-web/utils/UseForm';
import Constants from '@usas/ui-web/utils/Constants';

const useMemberCompetitionCategory = () => {
  const { basePersonState, getBasePerson, putBasePerson } = useBasePersonData();
  const { competitionGenderState } = useCompetitionGenderTypeData();
  const { officialCompetitionCategoryState, getOfficialCompetitionCategory, putOfficialCompetitionCategory } = useOfficialCompetitionCategoryData();
  // const { refreshState, putMemberInGoodStandingRefresh } = useMemberInGoodStandingRefreshData();
  const { handleSubmit, updateFormState, formState, setFormData, resetForm, errorState
  } = useForm(getInitialFormState(), submitFormCallback, validate);

  useEffect(() => {
    if (basePersonState.isObjLoaded === true) {
      const getOfficialCompetitionCategoryPromise = getOfficialCompetitionCategory(basePersonState.objData?.personId);

      if (getOfficialCompetitionCategoryPromise !== null) {
        getOfficialCompetitionCategoryPromise.then((newState) => {
          if (newState !== null) {
            setFormData({
              ...formState,
              competitionGenderTypeId: newState.objData.newCompetitionGenderTypeId,
              competitionCategoryChangeDate: formatDate(newState.objData.changeDate) === "01/01/0001" ? Constants.BLANK_DATE_STRING : formatDate(newState.objData.changeDate)
            }); 
          }
        }).catch((e) => {
          //TODO state error
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [basePersonState]);


  // const onRefreshClicked = (e) => {
  //   putMemberInGoodStandingRefresh(basePersonState.objData.personId);
  // }

  function createPersonObject(dataObj) {
    return {
      ...basePersonState.objData,
      competitionGenderTypeId: dataObj.newCompetitionGenderTypeId,
      competitionGenderType: undefined,
    };
  };

  function submitFormCallback(formState) {
    if (basePersonState.isSaving === false) {
      const updateObj = {
        newCompetitionGenderTypeId: formState.competitionGenderTypeId, 
        changeDate: formState.competitionCategoryChangeDate
      };

      const putOfficialCompetitionCategoryPromise = putOfficialCompetitionCategory(basePersonState.objData?.personId, updateObj);

      if (putOfficialCompetitionCategoryPromise !== null) {
        putOfficialCompetitionCategoryPromise.then((newState) => {
          if (newState !== null && newState !== undefined) {
            putBasePerson(basePersonState.objData.personId, createPersonObject(newState.objData));
          }
        }).catch((e) => {
          //TODO state error
        });
      }
    }
  }

  // function createPersonObject() {
  //   const birthDateObj = evaluateBirthDate(formState.birthDate);
  //   const showEmail = birthDateObj.isJunior === true || birthDateObj.isAdult === true;

  //   return {
  //     ...basePersonState.objData,
  //     email: showEmail === false ? '' : basePersonState.objData.email,
  //     competitionGenderTypeId: formState.competitionGenderTypeId,
  //     competitionGenderType: undefined,
  //     birthDate: formState.birthDate,
  //     usasPerson: basePersonState.objData.usasPerson ? {
  //       ...basePersonState.objData.usasPerson,
  //       maidenNameUsedAsLastName: formState.maidenNameUsedAsLastName,
  //       birthDateConfirmed: formState.birthDateConfirmed,
  //       birthCertificateUrl: formState.birthDateConfirmed === true ? null : basePersonState.objData.usasPerson.birthCertificateUrl
  //     } :
  //       {
  //         ...createUsasPersonIfUndefinedOrNull(basePersonState.objData.personId),
  //         maidenNameUsedAsLastName: formState.maidenNameUsedAsLastName,
  //         birthDateConfirmed: formState.birthDateConfirmed
  //       }
  //   };
  // };

  function getInitialFormState() {
    return {
      competitionGenderTypeId: '',
      competitionCategoryChangeDate: Constants.BLANK_DATE_STRING
    };
  };

  return {
    Constants,
    basePersonState,
    formState,
    errorState,
    competitionGenderState,
    // refreshState,
    onFormValueChanged: updateFormState,
    handleSubmit,
    resetForm
    // onRefreshClicked
  };
};

export default useMemberCompetitionCategory;